import React, { useRef,useState } from "react";
import emailjs from "@emailjs/browser";
import "./TextBoxMessage.css";
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Input,
  InputLabel,
  Paper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import IconButtonBorder from "../IconButtonBorder/IconButtonBorder";
import { contacts } from "../../information/information";
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import SubmitButton from "../SubmitButton/SubmitButton";

const SERVICE_ID = process.env.REACT_APP_SERVICE_ID || "";
const TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID || "";
const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY || "";
const TextBoxMessage = () => {
  const form: React.MutableRefObject<HTMLFormElement | null> = useRef(null);
  const theme = useTheme();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [load,setLoad] = useState(false);
  const [errorMsg,setErrorMsg] = useState("");
  const [sucessMsg,setSucessMsg] = useState("");
  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrorMsg("");
    setSucessMsg("")
    setLoad(true);
    if (form.current){
      emailjs
        .sendForm(SERVICE_ID, TEMPLATE_ID, form.current, {
          publicKey: PUBLIC_KEY,
        })
        .then(
          () => {
            setLoad(false);
            setSucessMsg("Successfully sent the message. The response will be sent to your given email within a day or less.");
          },
          (error) => {
            setLoad(false);
            setErrorMsg("Unable to send the message.")
          }
        );
      }
  };
  const { phoneNumber, gmail } = contacts;

  return (
    <Paper id="TextBoxMessage" elevation={8}>
      <Grid container className="textBoxContainer">
        <Grid
          item
          xs={12}
          sm={4}
          className="infoContact"
          style={{
            color: theme.palette.mode === "light" ? "white" : "black",
            backgroundColor: "#01d28e",
          }}
        >
          <Grid container gap={2} flexDirection={"column"}>
            <Grid item>
              <Typography className="formTitle">Let's get in touch</Typography>
            </Grid>
            <Grid item>
              <Typography className="formSupTitle">
                I'm open for any suggestion or just to have a chat
              </Typography>
            </Grid>
            {gmail && (
              <Grid item>
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  onClick={() => window.open(`mailto:${gmail}`)}
                  control={
                    <IconButtonBorder>
                      <EmailIcon />
                    </IconButtonBorder>
                  }
                  label={
                    <Typography className="iconButtonLabel">{gmail}</Typography>
                  }
                />
              </Grid>
            )}
            {phoneNumber && (
              <Grid item>
                <FormControlLabel
                  style={{ marginLeft: "0px" }}
                  onClick={() => window.open(`tel:${phoneNumber}`)}
                  control={
                    <IconButtonBorder>
                      <LocalPhoneIcon />
                    </IconButtonBorder>
                  }
                  label={
                    <Typography className="iconButtonLabel">
                      {phoneNumber}
                    </Typography>
                  }
                />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={8}>
          <form ref={form} onSubmit={sendEmail} className="inputContact">
            <Grid
              container
              flexDirection={"row"}
              className="messageForm"
              gap={2}
            >
              <Grid item xs={12} sm={6}>
                <InputLabel htmlFor="name-input" className="inputLabel">
                  Full Name
                </InputLabel>
                <Input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  id="name-input"
                  name="user_name"
                  required
                  placeholder="Name"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={5.5}>
                <InputLabel htmlFor="email-input" className="inputLabel">
                  Email
                </InputLabel>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  id="email-input"
                  name="reply_to"
                  required
                  placeholder="Email"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel htmlFor="subject-input" className="inputLabel">
                  Subject
                </InputLabel>
                <Input
                  name="subject"
                  id="Subject-input"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                  fullWidth
                  placeholder="Subject"
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel htmlFor="message-input" className="inputLabel">
                  Message
                </InputLabel>
                <Input
                  fullWidth
                  name="message"
                  id="message-input"
                  multiline
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required 
                  minRows={5}
                  placeholder="Message"
                />
              </Grid>
              {errorMsg && <Grid item xs={12}>
                 <Typography className="errorMsg">{errorMsg}</Typography>
              </Grid>}
              {sucessMsg && <Grid item xs={12}>
                 <Typography className="sucessMsg">{sucessMsg}</Typography>
              </Grid>}
              <Grid item style={{marginLeft:'auto'}}>
                <SubmitButton type="submit" value="Send" variant="contained" disabled={load}>
                  {(load)? "Please wait":"Send message"}
                </SubmitButton>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TextBoxMessage;
